export default __webpack_public_path__ + "static/media/profile_tip_charity.630c797a.svg";